import React, { Component } from 'react'
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import API from './../../config/api';
import httpRequest from '@/utils/httpRequest'
import './index.scss'

// 基地活动和所站活动
export default class index extends Component {
  constructor(props){
    super(props)
    this.state = {
      uuid:'',
      data:[],
    }
  }

  componentDidMount(){
    let url = window.location.href
    let parameter =  tools.getParams(url)
    this.setState({
      type:parameter.type,
      uuid:parameter.uuid
    },() => {
      this.getList()
    })
  }

  getList = () => {
    const {uuid} = this.state
    httpRequest({
      url: API.stationTeamList,
      type: 'get',
      data: {
        uuid:uuid,
        page:1
      }
    }).done((resp) => {
      if (resp.code === 0) {
        this.setState({
          data:resp.data
        })
      } else {
        Toast.fail(resp.msg || resp.error);
      }
    }).fail(jqXHR => {
      Toast.fail(jqXHR.msg || jqXHR.error);
    })
  }

  handle_add = (data) => {
    this.props.history.push(`/civilizationTeamDetail?uuid=${data.uuid}`)
  }

  render() {
    const {data} = this.state
    return (
      <div className='teamContainer'>
        {data.map((item,index) => {
          return <div key={index} className='module'>
                    <div className="coverBox"><img src={item.cover} alt=""/></div>
                    <div className="content">
                      <div className="title limit-line2">{item.title}</div>
                      <div className="info">
                        <div className="num">队伍规模：{item.team_num}人</div>
                        <button onClick={this.handle_add.bind(this,item)}>申请加入</button>
                      </div>
                    </div>
                  </div>
        })}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/CivilizationTeamList/index.js